import { render, staticRenderFns } from "./ConferenceNoticeModal.vue?vue&type=template&id=58778dc0&scoped=true"
import script from "./ConferenceNoticeModal.vue?vue&type=script&lang=js"
export * from "./ConferenceNoticeModal.vue?vue&type=script&lang=js"
import style0 from "./ConferenceNoticeModal.vue?vue&type=style&index=0&id=58778dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58778dc0",
  null
  
)

export default component.exports